import React, { useEffect, useState } from "react";
import { EyeOutlined, PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, PlusSquareFilled } from '@ant-design/icons';
import { DatePicker, Modal, Col, Row, Table, Space, Button, Form, FormInstance, Select, Input } from 'antd';
import { AlignType } from 'rc-table/lib/interface';
import dayjs from 'dayjs';

import { SelecionarArquivo } from "../../../components/Documentos/SelecionarArquivo";
import { errorMessage, mostrarInfo, successMessage } from "../../../utils/messages";
import { IDocumentoDirigenteHabilitacaoAnalise } from "../Componentes/InterfaceMandato";
import { ICtrlDoc } from "../../../Interfaces/DadosPrevicInterfaces";
import { IChaves } from "../../../Interfaces/Interfaces";

import { disabledDate, hasText } from "../../../utils/utilsFunctions";
import { getDocPdf } from "../../../services/apiDocumentos";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  documentos: IDocumentoDirigenteHabilitacaoAnalise[];
  setDocumentos: React.Dispatch<React.SetStateAction<IDocumentoDirigenteHabilitacaoAnalise[]>>;
  ctrlDoc: ICtrlDoc[];
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

export interface ICampos {
  visible?: string[];
  default?: string[];
  defaultNumberSelect?: number[];
  required?: number[];
  disabled?: number[];
}

const { Option } = Select;

const DirigenteHabilitacaoDocumentoAnalise = ({ form, documentos, setDocumentos, ctrlDoc, manter }: IProps) => {

  const [chave, setChave] = useState<number|undefined>();
  const [fileList, setFileList] = useState<IChaves>();

  const [exibirModalDoc, setExibirModalDoc] = useState(false);
  const [exibirDocCadastrado, setExibirDocCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");


  useEffect(() => {
    if (documentos.length === 0) {
      setExibirDocCadastrado("none")
    } else {
      setExibirDocCadastrado("inline")
    }
  }, [documentos]);


  useEffect(() => {
    if (chave) {
      setFileList(
        {
          idDocumento: chave,
          ativo: true,
        },
      );
    }
  }, [chave]);


  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);


  const controleDaGrid = (botao: string) => {
    if (!hasText(form.getFieldValue("nuProcesso"))) {
      mostrarInfo("Não é possível incluir novos documentos", "Processo ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalDoc(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
    if (manter === 2 || manter === 9) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarDoc = () => {
    if (!fileList || !fileList.idDocumento) {
      errorMessage("Selecione um arquivo para 'upload'.");
    } else {
      form
        .validateFields([
          "idHabilitacaoDocAnalise",
          "nuDocumento",
          "idCtrlDocTpDoc",
          "nmTpDoc",
          "dtDocumento",
        ])
        .then(() => {
          controleDaGrid("incluir");
          setDadosDocumento();
          successMessage("Documento Adicionado");
        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido ou não validado");
        });
    }
  };

  function setDadosDocumento() {
    setDocumentos([
      ...documentos,
      {
        idHabilitacaoDocAnalise: -1,
        nuDocumento: form?.getFieldValue("nuDocumento") ? form?.getFieldValue("nuDocumento").toUpperCase() : undefined,
        dtDocumento: form?.getFieldValue("dtDocumento") ? dayjs(form?.getFieldValue("dtDocumento")).format("YYYY-MM-DD") : "",
        idCtrlDocTpDoc: Number(form?.getFieldValue("idCtrlDocTpDoc")),
        nmTpDoc: form?.getFieldValue("nmTpDoc")?.toUpperCase(),
        idDocumento: chave,
        documentoChave: fileList,
        statusReg: 1,
        touched: true,
      },
    ]);
    form.resetFields([
      "idHabilitacaoDocAnalise",
      "nuDocumento",
      "idCtrlDocTpDoc",
      "nmTpDoc",
      "dtDocumento",
    ]);
    setChave(undefined);
    setFileList(undefined);
  }

  const columns = [
    {
      key: "1",
      title: "Tipo de Documento",
      dataIndex: "",
      render: (IDoc: IDocumentoDirigenteHabilitacaoAnalise) => <>{IDoc.ctrlDocTipoDocumento && IDoc.ctrlDocTipoDocumento.nmTpDoc ? (IDoc.ctrlDocTipoDocumento.nmTpDoc).toUpperCase() : IDoc.nmTpDoc?.toUpperCase()}</>,
    },
    {
      key: "2",
      title: "Número",
      dataIndex: "",
      render: (IDoc: IDocumentoDirigenteHabilitacaoAnalise) => <>{IDoc.nuDocumento}</>,
    },
    {
      key: "3",
      title: "Data",
      dataIndex: "",
      render: (IDoc: IDocumentoDirigenteHabilitacaoAnalise) => (
        <>
          {IDoc.dtDocumento !== undefined && IDoc.dtDocumento !== "" && dayjs(IDoc.dtDocumento).format("DD/MM/YYYY")}
        </>
      ),
    },
    {
      key: "111",
      title: "Arquivo",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoDirigenteHabilitacaoAnalise) => (
        <Button
          id="arquivo"
          shape="round"
          icon={<EyeOutlined />}
          htmlType="button"
          onClick={() => {
            getDocPdf(IDoc.idDocumento ? IDoc.idDocumento : (IDoc.documentoArquivo?.id!));
          }}
        />
      ),
    },
    {
      // Apenas Marca ou desmarca o campo ativo. Não existe a opção de alteração de documento. Somente exclusão e inclusão de um novo.
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoDirigenteHabilitacaoAnalise) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <DeleteOutlined
                title="Excluir documento ainda não gravado na base."
                style={{ color: "red", display: (IDoc?.idHabilitacaoDocAnalise && IDoc?.idHabilitacaoDocAnalise < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setDocumentos(documentos.filter((doc) => doc !== IDoc));
                }}
              />
            </div>

            <div style={{ display: (IDoc?.idHabilitacaoDocAnalise && IDoc?.idHabilitacaoDocAnalise > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    IDoc.statusReg = IDoc.statusReg === 1 ? 2 : 1;
                    IDoc.touched = true;
                    setDocumentos(pre => {
                      return pre.map(doc => {
                        if (doc.idHabilitacaoDocAnalise === IDoc.idHabilitacaoDocAnalise) {
                          return IDoc;
                        } else {
                          return doc;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    IDoc.statusReg = (IDoc.statusReg === 1 ? 2 : 1);
                    IDoc.touched = true;
                    setDocumentos(pre => {
                      return pre.map(doc => {
                        if (doc.idHabilitacaoDocAnalise === IDoc.idHabilitacaoDocAnalise) {
                          return IDoc;
                        } else {
                          return doc;
                        }
                      });
                    });
                  }}
                />
              </>

            </div>
          </Space>
      ),
    },

  ];

  const handlerTipoDocumento = async (value: any) => {
    form.setFieldsValue({
      "nmTpDoc": value.children,
      "idCtrlDocTpDoc": value.key,
    })
  };

  return (
    <>

      <Button

        style={{ display: exibirElementoAcaoAlteracao }}
        shape='round'
        onClick={() => {
          controleDaGrid("incluir documento");
        }}
        type='primary'
        icon={<PlusOutlined />}
      >
        Incluir Documento de Análise
      </Button>
      <>

        <Modal title="Incluir Documento de Análise" open={exibirModalDoc}
          style={{ top: 20 }}
          // width={750}
          destroyOnHidden={true}
          onCancel={() => {
            controleDaGrid("cancelar");
            form.resetFields([
              "idHabilitacaoDocAnalise",
              "nuDocumento",
              "idCtrlDocTpDoc",
              "nmTpDoc",
              "dtDocumento",
            ]);
          }}
          closable={false}
          cancelText="Cancelar"
          cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

          onOk={() => {
            validarDoc();
          }}
          okText="Incluir"
          okButtonProps={{ disabled: !chave, shape: "round", icon: <CheckOutlined /> }}
        >

          <Row>
            <Col xs={24} sm={20}>
              <Form.Item label="Tipo de Documento"
                labelAlign="left"
                labelCol={{ span: 20 }}
                name="nmTpDoc"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "O campo tipo de documento é obrigatório",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Tipo Documento'
                  onChange={(_, index) => {
                    handlerTipoDocumento(index);
                  }}
                // disabled={estadoModal === 2}
                >
                  {ctrlDoc?.map((e: any) => (
                    <Option key={e.idCtrlDocTpDoc} value={e.idCtrlDocTpDoc}>
                      {e.nmTpDoc}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

          </Row>

          <Row>
            <Col xs={24} sm={8}>
              <Form.Item label="Número"
                name="nuDocumento"
                colon={false}
              >
                <Input placeholder="Número" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label="Data"
                name="dtDocumento"
                colon={false}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                  placeholder="Selecionar Data"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row justify="space-between">
            <Col xs={24} md={12} xl={5}>
              <SelecionarArquivo
                setChave={setChave}
                identificador={true}
                label="Arquivo"
              />
            </Col>
          </Row>

        </Modal>

      </>

      <Row style={{ display: exibirDocCadastrado }}>
        <Col
          xs={24}
          sm={24}
        >
          <Table
            size="small" columns={columns} dataSource={documentos} pagination={false} />
        </Col>
      </Row>
    </>
  )
};

export default DirigenteHabilitacaoDocumentoAnalise;